import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import { createClassNames, translatable } from 'react-instantsearch-dom';
import GeoSearchContext from './GeoSearchContext';
import withGoogleMaps from './withGoogleMaps';
var cx = createClassNames('GeoSearch');
export var Control = function Control(_ref) {
  var googleMapsInstance = _ref.googleMapsInstance,
      translate = _ref.translate,
      isRefineOnMapMove = _ref.isRefineOnMapMove,
      hasMapMoveSinceLastRefine = _ref.hasMapMoveSinceLastRefine,
      toggleRefineOnMapMove = _ref.toggleRefineOnMapMove,
      refineWithInstance = _ref.refineWithInstance;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('control')
  }, isRefineOnMapMove || !hasMapMoveSinceLastRefine ? /*#__PURE__*/React.createElement("label", {
    className: cx('label')
  }, /*#__PURE__*/React.createElement("input", {
    className: cx('input'),
    type: "checkbox",
    checked: isRefineOnMapMove,
    onChange: toggleRefineOnMapMove
  }), translate('control')) : /*#__PURE__*/React.createElement("button", {
    className: cx('redo'),
    onClick: function onClick() {
      return refineWithInstance(googleMapsInstance);
    }
  }, translate('redo')));
};

var ControlWrapper = function ControlWrapper(props) {
  return /*#__PURE__*/React.createElement(GeoSearchContext.Consumer, null, function (_ref2) {
    var isRefineOnMapMove = _ref2.isRefineOnMapMove,
        hasMapMoveSinceLastRefine = _ref2.hasMapMoveSinceLastRefine,
        toggleRefineOnMapMove = _ref2.toggleRefineOnMapMove,
        refineWithInstance = _ref2.refineWithInstance;
    return /*#__PURE__*/React.createElement(Control, _extends({}, props, {
      isRefineOnMapMove: isRefineOnMapMove,
      hasMapMoveSinceLastRefine: hasMapMoveSinceLastRefine,
      toggleRefineOnMapMove: toggleRefineOnMapMove,
      refineWithInstance: refineWithInstance
    }));
  });
};

export default translatable({
  control: 'Search as I move the map',
  redo: 'Redo search here'
})(withGoogleMaps(ControlWrapper));